// extracted by mini-css-extract-plugin
module.exports = {"commentTooltip":"comment-button_commentTooltip_TS8"};